import {
  IResourceComponentsProps,
  useNavigation,
  useTable,
  useSelect,
  useList,
  useShow,
  useGetIdentity,
  useUpdate,
  useDelete,
  useImport,
  useCreateMany,
  useMany,
  CrudFilter,
} from '@pankod/refine-core'

import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  TableColumnType,
  Space,
  Typography,
  EditButton,
  DeleteButton,
  ShowButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  TagField,
  Progress,
  Menu,
  Tag,
  Form,
  Button,
  Popconfirm,
  message,
  Modal,
  Checkbox,
  Row,
  Col,
  Input,
  Select,
  Spin,
  Badge,
  useModal,
  Tabs,
  Divider,
} from '@pankod/refine-antd'
import { CSVLink } from 'react-csv'

import ReactMarkdown from 'react-markdown'
import { IGrade, IQuestion, IQuestionType, ISubject, ITeacherLevel, IQuestionStatus, ICheckList, IWorkRequest } from 'interfaces'
import { useEffect, useState } from 'react'
import { TableColumnsType } from 'antd'
import { CreateQuestion } from 'pages/questions'
import { EditQuestion } from 'pages/questions'
import { QuestionFilter } from 'components/filters/questionFilter'
import metaData from 'metadata/questions'

// import { getWorkRequestStatusCount, CompletionStatus } from 'helpers'

import { ReactMarkdownAllowedElements } from 'helpers/markdownConfig'
import { exportQuestions, getCount } from 'gql/query'
import { useUserContext } from 'context/user'
import { UploadQuestions } from './question_import_modal'
import { MarkRetired } from 'components/questions/mark_retired'
import { questionTemplateFormat } from 'helpers/import_template_format/importTemplate'

const { PlusOutlined, ExportOutlined, MailOutlined, AppstoreOutlined, SettingOutlined, FilterOutlined, DeleteOutlined } = Icons
const { Text, Link } = Typography
const { Search } = Input
type QuestionListProps = {
  request?: any
  updatePercentage?: any
}
type QuestionType = {
  title: string
  description: string
  created_by: string
  creator_id: string
  status: string
  subject_id: string
  theme_id: string
  sub_theme_id: string
  topic_id: string
  grade_ids: object[]
  option_type: string
  question_type_id: string
  bloom_level_id: string
  difficulty_level_id: string
  report_theme_id: string
  centa_standard_id: string
  strand_id: string
  centa_concept_id: string
  tn_taxonomy_id: string
  explanation_type_id: string
  competency_id: string
  teacher_level_id: string
  option_details: object[]
}
interface QuestionSearch {
  question_search: string
}
interface Count {
  forApprovalCount: number
  forReviewCount: number
  openCount: number
  openRequireAmendingCount: number
  publishedCount: number
  rejectedAtApprovalCount: number
  rejectedAtReviewCount: number
  requireAmendingCount: number
  retriedCount: number
  secondApprovalCount: number
  secondReviewCount: number
  totalCount: number
}
const { confirm } = Modal

export const QuestionUploadTableList: React.FC<QuestionListProps> = ({ request, updatePercentage }) => {
  const { data: user } = useGetIdentity()
  const { userRole } = useUserContext()
  const { mutate } = useCreateMany<IQuestion>()
  const role = user?.defaultRole
  const { show } = useNavigation()
  const [wrFilter, setWRFilter] = useState<CrudFilter[]>([])
  const [tableData, setTableData] = useState<object[]>([])
  const fileReader = new FileReader()
  const [file, setFile] = useState()
  const [loading, setLoading] = useState(false)
  const [array, setArray] = useState<object[]>([])
  const [totalValidQuestions, setTotalValidQuestions] = useState(0)
  const [tab, setTab] = useState('1')
  const { mutate: updateQuestionActiveFlag } = useUpdate()
  const { modalProps: uploadProps, show: showUpload, close: closeUpload } = useModal()
  const [formSearch] = Form.useForm<QuestionSearch>()
  const [searchText, setSearchText] = useState('')
  const [qFilter, setQFilter] = useState<CrudFilter[]>([])
  const [currentPage, setCurrentPage] = useState(parseInt(localStorage.getItem(`uploadedquestion-${userRole}`) ?? '1'))
  const [questionCount, setQuestionCount] = useState<Count>({
    forApprovalCount: 0,
    forReviewCount: 0,
    openCount: 0,
    openRequireAmendingCount: 0,
    publishedCount: 0,
    rejectedAtApprovalCount: 0,
    rejectedAtReviewCount: 0,
    requireAmendingCount: 0,
    retriedCount: 0,
    secondApprovalCount: 0,
    secondReviewCount: 0,
    totalCount: 0,
  })
  // const hideFilters=['grades','status']
  const headers = [
    { label: 'Subject Code', key: 'subject_code' },
    { label: 'Subject', key: 'subject' },
    { label: 'Theme', key: 'theme' },
    { label: 'Sub Theme', key: 'sub_theme' },
    { label: 'Topic', key: 'topic' },
    { label: 'Grade', key: 'grade' },
    { label: 'Taxonomy', key: 'tn_taxonomy' },
    { label: 'Difficulty Level', key: 'difficulty_level' },
    { label: 'Strand', key: 'strand' },
    { label: 'Status', key: 'status' },
    { label: 'Creator', key: 'creator' },
    { label: 'Question Type', key: 'question_type' },

    { label: 'Question Stem', key: 'title' },
    { label: 'Option  A', key: 'options[0].option_a' },
    { label: 'Option  B', key: 'options[1].option_b' },
    { label: 'Option  C', key: 'options[2].option_c' },
    { label: 'Option  D', key: 'options[3].option_d' },

    { label: 'Correct Answer', key: 'correct_answer' },

    { label: 'Left Label A', key: 'left_label_arr[0].left_label_1' },
    { label: 'Right Label A', key: 'right_label_arr[0].right_label_1' },

    { label: 'Left Label B', key: 'left_label_arr[1].left_label_2' },
    { label: 'Right Label B', key: 'right_label_arr[1].right_label_2' },

    { label: 'Left Label C', key: 'left_label_arr[2].left_label_3' },
    { label: 'Right Label C', key: 'right_label_arr[2].left_label_3' },

    { label: 'Left Label D', key: 'left_label_arr[3].left_label_4' },
    { label: 'Right Label D', key: 'right_label_arr[3].right_label_4' },

    { label: 'Insight A', key: 'insight[0].insight_a' },
    { label: 'Insight B', key: 'insight[1].insight_b' },
    { label: 'Insight C', key: 'insight[2].insight_c' },
    { label: 'Insight D', key: 'insight[3].insight_d' },

    { label: 'Component A', key: 'component_name[0].component_name' },

    { label: 'Rating 1', key: 'component_name[0].rating_1' },
    { label: 'Rating 2', key: 'component_name[0].rating_2' },
    { label: 'Rating 3', key: 'component_name[0].rating_3' },
    { label: 'Rating 4', key: 'component_name[0].rating_4' },

    { label: 'Weightage 1', key: 'component_name[0].weightage' },

    { label: 'Component B ', key: 'component_name[1].component_name' },
    { label: 'Rating 1', key: 'component_name[1].rating_1' },
    { label: 'Rating 2', key: 'component_name[1].rating_2' },
    { label: 'Rating 3', key: 'component_name[1].rating_3' },
    { label: 'Rating 4', key: 'component_name[1].rating_4' },
    { label: 'Weightage 2', key: 'component_name[1].weightage' },

    { label: 'Component C ', key: 'component_name[2].component_name' },
    { label: 'Rating 1', key: 'component_name[2].rating_1' },
    { label: 'Rating 2', key: 'component_name[2].rating_2' },
    { label: 'Rating 3', key: 'component_name[2].rating_3' },
    { label: 'Rating 4', key: 'component_name[2].rating_4' },

    { label: 'Weightage 3', key: 'component_name[2].weightage' },

    { label: 'Component D ', key: 'component_name[3].component_name' },

    { label: 'Rating 1', key: 'component_name[3].rating_1' },
    { label: 'Rating 2', key: 'component_name[3].rating_2' },
    { label: 'Rating 3', key: 'component_name[3].rating_3' },
    { label: 'Rating 4', key: 'component_name[3].rating_4' },
    { label: 'Weightage 4', key: 'component_name[3].weightage' },

    { label: 'Creator Comments', key: 'creator_comments' },
    { label: 'Reviewer Comments', key: 'reviewer_comments' },
    { label: 'Approver Comments', key: 'approver_comments' },
  ]

  const [currentFilter, setCurrentFilter] = useState('')
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [currentRecord, setCurrentRecord] = useState('')
  const [totalVariantQuestionCount, setTotalVariantQuestionCount] = useState(0)
  const [total, setTotal] = useState(0)
  const [processed, setProcessed] = useState(0)
  const {
    filters,
    setFilters,
    tableQueryResult: uploadedData,
    sorter,
    current,
    setCurrent,
    pageCount,
    setPageSize,
  } = useTable<IQuestion>({
    resource: 'questions',
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    initialFilter: [
      {
        field: 'request_type',
        operator: 'eq',
        value: 'Uploaded',
      },
    ],
    permanentFilter: [
      { field: 'active', operator: 'eq', value: 'true' },
      // { field: 'created_by', operator: 'eq', value: user?.id },
    ],
    metaData,
  })

  const handleOnSubmit = (fs: any) => {
    if (fs) {
      fileReader.onload = function (event: any) {
        const csvOutput = event.target.result
        csvFileToArray(csvOutput)
      }

      fileReader.readAsText(fs)
    }
  }
  const questionSearch = (value: string) => {
    let numValue = Number(value)
    setFilters(prevFilters => {
      const updatedFilters = prevFilters.filter((item: any) => item.field !== 'question_id' && item.field !== 'title')
      if (!isNaN(numValue) && value.trim() !== '') {
        return [
          ...updatedFilters,
          {
            field: 'question_id',
            operator: 'eq',
            value: numValue,
          },
        ]
      } else {
        return [
          ...updatedFilters,
          {
            field: 'title',
            operator: 'contains',
            value: `%${value}%`,
          },
        ]
      }
    })
  }
  const clearSearch = () => {
    filters.splice(0, filters.length)
    setFilters([])

    formSearch?.resetFields()
    setSearchText('')
    setFilters(qFilter)
    // tableQueryResult?.refetch()
  }
  // const handleChange = (e: any) => {
  //   setFile(e.target.files[0])
  //   setLoading(true)
  //   handleOnSubmit(e.target.files[0])
  // }
  const csvFileToArray = (result: string) => {
    const csvHeader = result.slice(0, result.indexOf('\n')).split(',')
    const csvRows = result.slice(result.indexOf('\n') + 1).split('\n')

    const array = csvRows.map(i => {
      const values = i.split(',')

      const obj = csvHeader.reduce((object: any, header: any, index: any) => {
        object[header] = values[index]

        return object
      }, {})
      return obj
    })

    setArray(array)
  }

  const findCount = async () => {
    try {
      let userId = user?.id
      let isAdmin = userRole === 'admin'
      let userrole = userRole
      const resource = 'uploaded_question'
      const responseFindQuestionCount: any = await getCount({ userId, isAdmin, userrole, resource })
      let forApprovalCount = responseFindQuestionCount?.forApprovalCount?.aggregate?.count
      let forReviewCount = responseFindQuestionCount?.forReviewCount?.aggregate?.count
      let openCount = responseFindQuestionCount?.openCount?.aggregate?.count
      let openRequireAmendingCount = responseFindQuestionCount?.openRequireAmendingCount?.aggregate?.count
      let publishedCount = responseFindQuestionCount?.publishedCount?.aggregate?.count
      let rejectedAtApprovalCount = responseFindQuestionCount?.rejectedAtApprovalCount?.aggregate?.count
      let rejectedAtReviewCount = responseFindQuestionCount?.rejectedAtReviewCount?.aggregate?.count
      let requireAmendingCount = responseFindQuestionCount?.requireAmendingCount.aggregate?.count
      let retriedCount = responseFindQuestionCount?.retriedCount?.aggregate?.count
      let secondApprovalCount = responseFindQuestionCount?.secondApprovalCount?.aggregate?.count
      let secondReviewCount = responseFindQuestionCount?.secondReviewCount?.aggregate?.count
      let totalCount = parseInt(
        forApprovalCount +
          forReviewCount +
          openCount +
          openRequireAmendingCount +
          publishedCount +
          rejectedAtApprovalCount +
          rejectedAtReviewCount +
          requireAmendingCount +
          retriedCount +
          secondApprovalCount +
          secondReviewCount
      )
      setQuestionCount({
        forApprovalCount,
        forReviewCount,
        openCount,
        openRequireAmendingCount,
        publishedCount,
        rejectedAtApprovalCount,
        rejectedAtReviewCount,
        requireAmendingCount,
        retriedCount,
        secondApprovalCount,
        secondReviewCount,
        totalCount,
      })
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    let question_arr: QuestionType[] = []
    let optionText = ['Option_A', 'Option_B', 'Option_C', 'Option_D']
    let fillText = ['Fill_Right_Answer_A', 'Fill_Right_Answer_B', 'Fill_Right_Answer_C', 'Fill_Right_Answer_D']
    let optionFlag = ['Option_Flag_A', 'Option_Flag_B', 'Option_Flag_C', 'Option_Flag_D']
    let insightText = ['Insight_A', 'Insight_B', 'Insight_C', 'Insight_D']
    let leftLabelText = ['Left_Label_A', 'Left_Label_B', 'Left_Label_C', 'Left_Label_D']
    let rightLabelTextt = ['Right_Label_A', 'Right_Label_B', 'Right_Label_C', 'Right_Label_D']
    let componentName = ['A', 'B', 'C', 'D']
    if (array.length > 0) {
      array.map((item: any) => {
        let option_details: object[] = []
        let option_flag = ''

        if (item?.Question_Type === 'MCQ') {
          optionText.map((options: any, i: any) => {
            if (item?.Correct_Answer === item[options]) {
              option_flag = 'Right Answer'
            } else {
              option_flag = item[optionFlag[i]]
              option_details.push({
                option_text: item[options],
                option_flag: option_flag,
                option_insight: item[insightText[i]],
              })
            }
          })
        } else if (item?.Question_Type === 'Fill') {
          fillText.map((rightans: any, i: any) => {
            option_details.push({
              right_answer: item[rightans],
              option_insight: item[insightText[i]],
            })
          })
        } else if (item?.Question_Type === 'Match') {
          leftLabelText.map((leftlab: any, i: any) => {
            option_details.push({
              left_label_text: item[leftlab],
              right_label_text: item[rightLabelTextt[i]],
              option_insight: item[insightText[i]],
            })
          })
        } else if (item?.Question_Type === 'ShortAnswer') {
          let cName = 'Component_'
          let rName = 'Rating_'
          let wName = 'Weightage_'
          componentName.map((comp: any, i: any) => {
            option_details.push({
              component_name: item[cName + comp],
              rating_1: item[rName + comp + 1],
              rating_2: item[rName + comp + 2],
              rating_3: item[rName + comp + 3],
              rating_4: item[rName + comp + 4],
              weightage: item[wName + comp],
            })
          })
        }
        if (item?.Title !== '') {
          question_arr.push({
            title: item?.Title,
            description: item?.Description,
            created_by: user?.id,
            creator_id: user?.id,
            status: item?.Status,
            subject_id: item?.Subject?.replace(/\,/g, ''),
            theme_id: item?.Theme === '' ? null : item?.Theme,
            sub_theme_id: item?.Sub_Theme === '' ? null : item?.Sub_Theme,
            topic_id: item?.Topic === '' ? null : item?.Topic,
            grade_ids: item?.Grade === '' ? null : item?.Grade,
            option_type: item?.Option_Type,
            question_type_id: item?.Question_Type,
            bloom_level_id: item?.Bloom_Level === '' ? null : item?.Bloom_Level,
            difficulty_level_id: item?.Difficulty_Level === '' ? null : item?.Difficulty_Level,
            report_theme_id: item?.Report_Theme === '' ? null : item?.Report_Theme,
            centa_standard_id: item?.Centa_Standard === '' ? null : item?.Centa_Standard,
            strand_id: item?.Strand === '' ? null : item?.Strand,
            centa_concept_id: item?.Centa_Concept === '' ? null : item?.Centa_Concept,
            tn_taxonomy_id: item?.Taxonomy === '' ? null : item?.Taxonomy,
            explanation_type_id: item?.Explanation_Type === '' ? null : item?.Explanation_Type,
            competency_id: item?.Competency === '' ? null : item?.Competency,
            teacher_level_id: item?.Teacher_Level === '' ? null : item?.Teacher_Level,
            option_details: option_details,
          })
        }
      })

      // mutate({
      //   resource: 'questions',
      //   values: question_arr,
      // })
    }
  }, [array])

  const handleOk = () => {
    setIsModalVisible(true)
  }

  const handleCancel = () => {
    setIsModalVisible(false)
  }
  const showModal = (id: string) => {
    setCurrentRecord(id)
    setIsModalVisible(true)
  }
  useEffect(() => {
    if (!request) {
      setCurrent(parseInt(localStorage.getItem(`uploadedquestion-${userRole}`) ?? '1'))
      setCurrentPage(parseInt(localStorage.getItem(`uploadedquestion-${userRole}`) ?? '1'))
    } else {
      setCurrent(1)
      setCurrentPage(1)
    }
  }, [userRole])

  const [comments, setComments] = useState('')
  var selectedReasons: string[] = []

  //This is needed, because varaintcreator needs
  //access to all question in variant question creation
  useEffect(() => {
    let arrFilter: CrudFilter[] = []
    filters.splice(0, filters.length)
    setFilters([])
    if (userRole === 'variantcreator') {
      arrFilter = []
      arrFilter.push(
        {
          field: 'created_by',
          operator: 'eq',
          value: user?.id,
        }
        // {
        //   field: 'user_type',
        //   operator: 'eq',
        //   value: 'variantcreator',
        // }
      )
    } else if (userRole === 'qcreator') {
      arrFilter = []
      arrFilter.push(
        {
          field: 'created_by',
          operator: 'eq',
          value: user?.id,
        }
        // {
        //   field: 'user_type',
        //   operator: 'eq',
        //   value: 'qcreator',
        // }
      )
    }

    setWRFilter(arrFilter)
    setFilters(arrFilter)
    findCount()
  }, [userRole])

  const { queryResult, setShowId } = useShow<IQuestion>({
    resource: 'questions',
    metaData,
  })

  const { data: showQueryResult } = queryResult
  const record = showQueryResult?.data
  console.log(filters, 'filters')

  useEffect(() => {
    if (request?.id !== '' && request?.id !== undefined) {
      setFilters([
        {
          field: 'work_request_id',
          operator: 'eq',
          value: request?.id,
        },
      ])
    }
  }, [request])
  const {
    formProps: createFormProps,
    modalProps: createModalProps,
    show: createShow,
  } = useModalForm({
    resource: 'questions',
    action: 'create',
    redirect: false,
    metaData,
  })
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    close: editClose,
    show: editShow,
  } = useModalForm({
    resource: 'questions',
    action: 'edit',
    redirect: false,
    metaData,
  })

  const cancel = (e: React.MouseEvent<HTMLElement>) => {
    message.error('Click on No')
  }
  const onChangeReasons = (checkedValues: any[]) => {
    selectedReasons = checkedValues
  }

  const changeFilters = (field: string, value: string, operator: any, isRemove: any) => {
    if (isRemove) {
      const updatedFilters = filters.filter((item: any) => item.field !== field)
      const removeIndex = filters.findIndex((item: any) => item.field === field)
      if (removeIndex !== -1) {
        filters.splice(removeIndex, 1)
        setFilters(updatedFilters)
      }
    } else {
      setCurrent(1)
      if (field !== 'all') {
        if (currentFilter === 'status') {
          filters.pop()
        }

        setFilters([
          {
            field: field,
            operator: operator,
            value: value,
          },
        ])
      } else if (field === 'all') {
        filters.splice(0, filters.length)
        if (request?.id !== '') {
          filters.splice(0, filters.length)
          setFilters(wrFilter)
          setFilters([
            {
              field: 'request_type',
              operator: 'eq',
              value: 'Uploaded',
            },
            { field: 'active', operator: 'eq', value: 'true' },
            { field: 'user_type', operator: 'eq', value: userRole },
            { field: 'created_by', operator: 'eq', value: user?.id },
          ])
        }
      }

      setCurrentFilter(field)
    }
  }
  console.log({ qFilter, filters })
  useEffect(() => {
    let arr: object[] = []
    let optionText = ['option_a', 'option_b', 'option_c', 'option_d']
    let option_arr: object[] = []
    let correct_ans: string = ''
    let insight_arr: object[] = []
    let insightText = ['insight_a', 'insight_b', 'insight_c', 'insight_d']
    let left_label_text = ['left_label_1', 'left_label_2', 'left_label_3', 'left_label_4']
    let left_label_arr: object[] = []
    let right_label_text = ['right_label_1', 'right_label_2', 'right_label_3', 'right_label_4']
    let right_label_arr: object[] = []
    let rating_arr: object[] = []
    let rating_text = ['rating_1', 'rating_2', 'rating_3', 'rating_4']
    let component_arr: object[] = []
    let component_text = ['component_1', 'component_2', 'component_3', 'component_4']

    let weightage_arr: object[] = []
    let weightage_text = ['weightage_1', 'weightage_2', 'weightage_3', 'weightage_4']

    exportQuestions().then((response: any) => {
      // setCreatorList(response.users)

      if (response?.questions?.length > 0) {
        response?.questions?.map((item: any, index: any) => {
          if (item?.question_type_id == 'MCQ') {
            option_arr = []
            left_label_arr = []
            right_label_arr = []
            correct_ans = ''
            insight_arr = []
            item?.option_details !== null &&
              item?.option_details?.length > 0 &&
              item?.option_details?.map((option: any, i: any) => {
                // arr[index][optionText[i]]= option?.option_text

                option_arr.push({
                  [optionText[i]]: option?.option_text,
                })

                if (option?.option_flag === 'Right Answer') {
                  correct_ans = option?.option_text
                }

                insight_arr.push({
                  [insightText[i]]: option?.option_insight,
                })
              })
          } else if (item?.question_type_id == 'Fill') {
            option_arr = []
            left_label_arr = []
            right_label_arr = []
            correct_ans = ''
            insight_arr = []
            item?.option_details !== null &&
              item?.option_details?.length > 0 &&
              item?.option_details?.map((option: any, i: any) => {
                correct_ans = correct_ans?.concat(option?.right_answer)
                correct_ans = correct_ans?.concat(',')
              })
          } else if (item?.question_type_id == 'Match') {
            option_arr = []
            left_label_arr = []
            right_label_arr = []
            correct_ans = ''
            insight_arr = []

            item?.option_details !== null &&
              item?.option_details?.length > 0 &&
              item?.option_details?.map((option: any, i: any) => {
                left_label_arr.push({
                  [left_label_text[i]]: option?.left_label_text,
                })
                right_label_arr.push({
                  [right_label_text[i]]: option?.right_label_text,
                })

                insight_arr.push({
                  [insightText[i]]: option?.option_insight,
                })
              })
          } else {
            option_arr = []
            left_label_arr = []
            right_label_arr = []
            correct_ans = ''
            insight_arr = []
            rating_arr = []
            component_arr = []
            weightage_arr = []

            item?.option_details !== null &&
              item?.option_details?.length > 0 &&
              item?.option_details?.map((option: any, i: any) => {
                component_arr.push(option)
              })
          }

          arr.push({
            subject_code: item?.subject?.code,
            subject: item?.subject?.name,
            theme: item?.theme?.name,
            sub_theme: item?.sub_theme?.name,
            topic: item?.topic?.name,
            grade: item?.grade?.name,
            taxonomy: item?.tn_taxonomy?.name,
            difficulty_level: item?.difficulty_level?.name,
            strand: item?.strand?.name,
            status: item?.status,
            creator: item?.userByCreatorId?.displayName,
            question_type: item?.question_type_id,
            title: item?.title,
            options: option_arr,
            left_label_arr: left_label_arr,
            right_label_arr: right_label_arr,
            correct_answer: correct_ans,
            insight: insight_arr,
            rating_arr: rating_arr,
            component_name: component_arr,
            weightage: weightage_arr,
            creator_comments: item?.creator_notes,
            reviewer_comments: item?.reviewer_notes,
            approver_comments: item?.approver_notes,
          })
        })
      }
    })
    setTableData(arr)
  }, [])
  const gradeList = useList<IGrade>({
    resource: 'grades',
    metaData: {
      fields: ['id', 'name'],
    },
    config: {
      pagination: { pageSize: 1000 },
    },
  })
  const reloadUploadedData = () => {
    uploadedData.refetch()
  }
  const columns: TableColumnsType<IQuestion> = [
    {
      dataIndex: 'question_id',
      title: 'Id',
    },

    {
      title: 'Name',
      dataIndex: 'name',
      render: (_, record) => (
        <ShowButton
          size="small"
          type="link"
          icon={null}
          recordItemId={record?.id}
          onClick={() => {
            show('questions', record?.id)
          }}
        >
          <Text
            style={{
              width: 150,
              textAlign: 'left',
              color: '#6659FF',
              cursor: 'pointer',
            }}
            ellipsis={{ tooltip: record?.title }}
          >
            <ReactMarkdown
              allowedElements={ReactMarkdownAllowedElements}
              components={{
                p: ({ node, ...props }) => <p style={{ margin: '0' }} {...props} />,
                em: ({ node, ...props }) => <em style={{ margin: '0' }} {...props} />,
                strong: ({ node, ...props }) => <strong style={{ margin: '0' }} {...props} />,
                ol: ({ node, ...props }) => <ol style={{ margin: '0' }} {...props} />,
                ul: ({ node, ...props }) => <ul style={{ margin: '0' }} {...props} />,
                li: ({ node, ...props }) => <li style={{ margin: '0' }} {...props} />,
              }}
            >
              {record?.title.length < 30 ? record?.title.substring(0, 30) : record?.title.substring(0, 30).concat('...')}
            </ReactMarkdown>
          </Text>
        </ShowButton>
      ),
    },
    {
      dataIndex: 'question_type_id',
      title: 'Q Type',
    },
    {
      dataIndex: 'source',
      title: 'Source',
    },

    {
      dataIndex: 'subject_id',
      title: 'Subject',
      render: (_, record) => (
        <Text style={{ width: 175, textAlign: 'left' }} ellipsis={{ tooltip: record?.subject?.name }}>
          {record?.subject?.name}
        </Text>
      ),
    },

    {
      dataIndex: 'status',
      title: 'Status',
      width: 100,
      className: 'ant-table-column-sort',
      render: value => (
        <Tag
          color={
            value === 'Published'
              ? 'green'
              : value === 'Rejected at Review' || value === 'Rejected at Approval' || value === 'Retired'
              ? 'volcano'
              : value === 'Open (Require Amending)' || value === 'For Review (Require Amending)'
              ? 'pink'
              : 'geekblue'
          }
        >
          {value}
        </Tag>
      ),
    },
    {
      dataIndex: 'created_at',
      title: 'Created At',
      sorter: (a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime(),
      render: value => <DateField format="DD-MMM-YY" value={value} />,
    },

    {
      dataIndex: 'creator_id',
      title: 'Creator',

      render: (_, record) => (
        <Text style={{ textAlign: 'left' }} ellipsis={{ tooltip: record?.userByCreatorId?.displayName }}>
          {record?.userByCreatorId?.displayName}
        </Text>
      ),
    },
    //-------------bloom level, grade added
    {
      dataIndex: 'bloom_level_id',
      title: 'Bloom level',

      render: (_, record) => (
        <Text style={{ textAlign: 'left' }} ellipsis={{ tooltip: record?.bloom_level?.name }}>
          {record?.bloom_level?.name}
        </Text>
      ),
    },

    {
      dataIndex: 'grade_ids',
      title: 'Grade',
      render: (_, { question_grades, grade_ids }) => (
        <>
          {question_grades?.length > 0 ? (
            <div>
              {question_grades?.length > 1 ? (
                <Badge size="small" count={question_grades?.length - 1} style={{ background: '#6659ff' }}>
                  {/* <Tooltip title="prompt text" color={'#6659ff'} key={'#6659ff'}> */}
                  <Tag color={'blue'} key={question_grades?.[0]?.grade?.name}>
                    {question_grades?.[0]?.grade?.name}
                  </Tag>
                  {/* </Tooltip> */}
                </Badge>
              ) : (
                <Tag color={'blue'} key={question_grades?.[0]?.grade?.name}>
                  {question_grades[0]?.grade?.name}
                </Tag>
              )}
            </div>
          ) : null}
        </>
      ),
    },

    // {
    //   dataIndex: 'topic_id',
    //   title: 'Topic',

    //   render: (_, record) => (
    //     <Text style={{ textAlign: 'left' }} ellipsis={{ tooltip: record?.userByCreatorId?.displayName }}>
    //       {record?.topic?.name}
    //     </Text>
    //   ),
    // },
    {
      dataIndex: 'difficulty_level_id',
      title: 'Difficulty',

      render: (_, record) => (
        <Text style={{ width: 120, textAlign: 'left' }} ellipsis={{ tooltip: record?.difficulty_level?.name }}>
          {record?.difficulty_level?.name}
        </Text>
      ),
    },

    ///

    {
      title: 'Actions',
      dataIndex: 'actions',
      render: (_, record) => (
        <Space>
          {userRole === 'admin' ||
          userRole === 'qbincharge' ||
          (userRole === 'variantcreator' && (record?.status === 'Open' || record?.status === 'Open (Require Amending)')) ||
          (userRole === 'qcreator' && (record?.status === 'Open' || record?.status === 'Open (Require Amending)')) ||
          (userRole === 'qreviewer' && (record?.status === 'For Review' || record?.status === 'For Review (Require Amending)')) ||
          (userRole === 'qapprover' && record?.status === 'For Approval') ? (
            <EditButton
              hidden={
                (request?.request_type === 'V' && userRole === 'qcreator') ||
                (request?.request_type === 'Q' && userRole === 'variantcreator') ||
                record?.status === 'Retired'
              }
              key="edit"
              size="small"
              type="link"
              hideText
              recordItemId={record.id}
              onClick={() => {
                editShow(record?.id)
                setShowId(record?.id)
              }}
            />
          ) : null}
          {userRole === 'qbincharge' && record?.status !== 'Retired' ? (
            <Button type="primary" onClick={() => showModal(record?.id)}>
              Mark Retired
            </Button>
          ) : null}
          {userRole === 'admin' ||
          userRole === 'qbincharge' ||
          (userRole === 'qcreator' && record?.status === 'Open') ||
          (userRole === 'variantcreator' && record?.status === 'Open') ? (
            <Popconfirm
              title="Are you sure ?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => {
                updateQuestionActiveFlag({ resource: 'questions', id: record?.id, values: { active: 'false' } })
                // changeStatus()
              }}
            >
              <Button
                danger
                size="small"
                type="link"
                icon={null}
                hidden={
                  (request?.request_type === 'V' && userRole === 'qcreator') ||
                  (request?.request_type === 'Q' && userRole === 'variantcreator') ||
                  record?.status === 'Retired'
                }
              >
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          ) : null}
        </Space>
      ),
    },
  ]
  const onChange = (page: number, pageSize: number): void => {
    setCurrent(page)
    setPageSize(pageSize)
    setCurrentPage(page)
    localStorage.setItem(`uploadedquestion-${userRole}`, page.toString())
  }

  // useEffect(() => {
  //   const { total_valid_questions } = getWorkRequestStatusCount(request)
  //   setTotalValidQuestions(total_valid_questions)
  // }, [request])

  // const changeStatus = () => {
  //   workRequestData?.refetch()
  //   // getWorkRequestStatusCount(workRequestData?.data?.data[0])
  //   const { total_valid_questions } = getWorkRequestStatusCount(workRequestData?.data?.data[0])
  //   setTotalValidQuestions(total_valid_questions)
  //   updatePercentage()
  // }

  useEffect(() => {
    if (request?.request_type === 'V') {
      let _totalVariantQuestionCount = 0
      request?.variant_options?.forEach((item: any) => {
        _totalVariantQuestionCount = _totalVariantQuestionCount + JSON.parse(item?.variant_count)
      })
      setTotalVariantQuestionCount(_totalVariantQuestionCount)
    }
  }, [request])
  const { handleChange } = useImport<IQuestionType>({
    onFinish: results => {
      window.alert(JSON.stringify(results))
    },
    onProgress: ({ totalAmount, processedAmount }) => {
      //  setProcessed(processedAmount)
      //  setTotal(totalAmount)
    },
  })
  const csvData = [questionTemplateFormat.map(item => item.toString())]
  const labels: { keyName: keyof Count; labelName: string }[] = [
    { keyName: 'totalCount', labelName: 'Total Questions Created' },
    { keyName: 'openCount', labelName: 'Open Questions' },
    { keyName: 'forReviewCount', labelName: 'Questions for Review' },
    { keyName: 'retriedCount', labelName: 'Retired Questions' },
    { keyName: 'publishedCount', labelName: 'Published Questions' },
    { keyName: 'rejectedAtApprovalCount', labelName: 'Rejected At Approval Questions' },
    { keyName: 'forApprovalCount', labelName: 'For Approval Questions' },
    { keyName: 'rejectedAtReviewCount', labelName: 'Rejected At Review Questions' },
    { keyName: 'requireAmendingCount', labelName: 'Amending Required Questions' },
    { keyName: 'secondApprovalCount', labelName: 'For Second Approval Questions' },
    { keyName: 'openRequireAmendingCount', labelName: 'Open (Require Amending) Questions' },
    { keyName: 'secondReviewCount', labelName: 'For Second Review Questions' },
  ]

  return (
    <List
      title="Uploaded Questions"
      pageHeaderProps={{
        extra: [
          <>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {/* {request === undefined && tableData?.length > 0 ? (
                userRole === 'admin' || userRole === 'srmanager' ? (
                  <CSVLink
                    data={tableData}
                    asyncOnClick={true}
                    filename={`Questions_${Math.round(new Date().getTime() / 1000)}`}
                    className="ant-btn ant-btn-default"
                    headers={headers}
                  >
                    <ExportOutlined /> Export
                  </CSVLink>
                ) : null
              ) : null} */}
              {request === undefined &&
                (userRole === 'qcreator' || userRole === 'variantcreator' || userRole === 'admin' || userRole === 'qbincharge') && (
                  <>
                    <Button icon={<Icons.ImportOutlined />} onClick={showUpload}>
                      Import
                    </Button>

                    <Button key="export paper" type="default" style={{ marginLeft: '10px' }}>
                      <CSVLink key="export" data={csvData} filename={`question_importFormat${Math.round(new Date().getTime() / 1000)}`}>
                        <ExportOutlined /> Download Import Format
                      </CSVLink>
                    </Button>
                  </>
                )}

              <RefreshButton key="refresh" onClick={() => uploadedData?.refetch()} style={{ marginLeft: 10 }} />
            </div>
            <>
              {/* {request?.request_type === 'V'
                ? userRole === 'variantcreator' &&
                  request?.creator_id === user?.id &&
                  request?.status !== 'Draft' && (
                    <CreateButton
                      disabled={
                        request?.request_type === 'V' ? !(totalValidQuestions < totalVariantQuestionCount) : !(totalValidQuestions < request?.count)
                      }
                      key="create"
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        createFormProps.form?.resetFields()
                        createShow()
                      }}
                      hidden={!request?.id}
                    />
                  )
                : request?.request_type === 'Q'
                ? userRole === 'qcreator' &&
                  request?.creator_id === user?.id &&
                  request?.status !== 'Draft' && (
                    <CreateButton
                      disabled={
                        request?.request_type === 'V' ? !(totalValidQuestions < totalVariantQuestionCount) : !(totalValidQuestions < request?.count)
                      }
                      key="create"
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        createFormProps.form?.resetFields()
                        createShow()
                      }}
                      hidden={!request?.id}
                    />
                  )
                : null} */}
            </>
          </>,
        ],
      }}
    >
      <Divider />
      <Row gutter={[16, 16]}>
        {labels.map(countDetails => {
          if (questionCount[countDetails.keyName] && questionCount[countDetails.keyName] > 0) {
            return (
              <Col xs={24} sm={24} md={8} lg={8} xl={6}>
                <div
                  style={{
                    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                    padding: '1rem',
                    height: '4rem',
                    borderRadius: '10px',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <h4>
                    {countDetails?.labelName}:
                    <span style={{ fontSize: '16px', marginLeft: '5px', fontWeight: 'bold' }}>{questionCount[countDetails.keyName] || 0}</span>
                  </h4>
                </div>
              </Col>
            )
          }
        })}
      </Row>

      <Divider />
      {/* centa seach box added */}
      {request?.id === null || request?.id === undefined ? (
        <>
          <Divider style={{ margin: ' 0', paddingBottom: 5, marginTop: 20 }} />
          <Form form={formSearch}>
            <Row gutter={[16, 0]} style={{ alignItems: 'center' }}>
              <Col lg={22}>
                <Search
                  name="question_search"
                  placeholder="input search text"
                  enterButton="Search"
                  size="large"
                  onSearch={questionSearch}
                  value={searchText}
                  onChange={(e: any) => setSearchText(e?.target?.value)}
                />
              </Col>
              <Col lg={2}>
                <Button htmlType="button" onClick={clearSearch}>
                  Clear{' '}
                </Button>
              </Col>
            </Row>
          </Form>
        </>
      ) : null}
      <Divider style={{ margin: ' 0', paddingBottom: 5, marginTop: 20 }} />
      {/* centa seach box added */}
      <QuestionFilter changeFilters={changeFilters} source={'Questions'} hideFilters={['status']} />

      <Table
        size="small"
        dataSource={uploadedData?.data?.data}
        scroll={{ x: true }}
        columns={columns}
        loading={uploadedData?.isLoading}
        pagination={{
          total: uploadedData?.data?.total,
          onChange,
          current: currentPage,
        }}
      />

      <MarkRetired isModalVisible={isModalVisible} handleOk={handleOk} handleCancel={handleCancel} id={currentRecord} />
      <CreateQuestion modalProps={createModalProps} formProps={createFormProps} request={request} updatePercentage={updatePercentage} />
      <EditQuestion modalProps={editModalProps} formProps={editFormProps} record={record} close={editClose} updatePercentage={updatePercentage} />
      <UploadQuestions modalProps={uploadProps} close={closeUpload} reloadUploadedData={reloadUploadedData} />
    </List>
  )
}
